
<div style="display: flex; flex-flow: row nowrap; gap: .4em; align-items: center;">

	<span>{{label}}</span>

	<span
		*ngIf="info && info.length"
		class="customBtn btnShowInfo"
		(click)="showInfo()"
	>
		<span class="material-icons">info_outline</span>
	</span>

</div>